/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FieldListEditWrapper } from "cms/fields/field-lists/field-list-wrapper";
import { JSONFieldItemEdit } from "./edit-item";

const JSONFieldEdit = () => {
    
    return (
        <FieldListEditWrapper>
            <JSONFieldItemEdit />
        </FieldListEditWrapper>
    );
};
JSONFieldEdit.displayName = "JSONFieldEdit";
export { JSONFieldEdit };
